import { render, staticRenderFns } from "./SearchPaginator.vue?vue&type=template&id=347519f3"
import script from "./SearchPaginator.vue?vue&type=script&lang=js"
export * from "./SearchPaginator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports